// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"DefaultPageFormat_wrapper__PXM99","gigass":"DefaultPageFormat_gigass__07_bC"};